import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { InvestmentStrategyItemDesktop } from './Desktop';
import { InvestmentStrategyItemMobile } from './Mobile';
import { InvestmentStrategyItemTablet } from './Tablet';
import { InvestmentStrategyItemTypes } from './types';

export const InvestmentStrategyItem: React.FC<InvestmentStrategyItemTypes.Props> = (props) => {
  return useBreakpointValue({
    base: <InvestmentStrategyItemMobile {...props} />,
    sm: <InvestmentStrategyItemTablet {...props} />,
    lg: <InvestmentStrategyItemDesktop {...props} />,
  });
};
